import { z } from 'zod';

export const AnswerCardPinThemeSettingsSchema = z.object({
  backgroundColor: z.string().optional(),
  textColor: z.string().optional(),
  borderColor: z.string().optional(),
  borderSize: z.number().optional(),
  correctnessColors: z
    .object({
      correct: z.string().optional(),
      partiallyCorrect: z.string().optional(),
      incorrect: z.string().optional(),
    })
    .optional(),
});

export type PinThemeAnswerCard = z.infer<typeof AnswerCardPinThemeSettingsSchema>;
